import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { PlatformDashboard } from '@/features/platform/pages/PlatformDashboard'

const searchSchema = z.object({
  tab: z
    .enum(['overview', 'subscribers', 'expenses', 'financials', 'users', 'audit', 'inbox', 'broadcast', 'scan-points'])
    .catch('overview'),
})

export const Route = createFileRoute('/_platform/platform/')({
  validateSearch: searchSchema,
  component: PlatformDashboard,
})
